import React, { useState, useEffect, useRef } from "react";
import ProfileDownload from "../Website/ProfileDownload";
import "react-circular-progressbar/dist/styles.css";
import { usePopup } from "../Common/PopupContext";
import { PopupProvider } from "../Common/PopupContext";
import CustomToastContainer from "../Common/CustomToastContainer";

import { getUserData } from "../../helpers/utils";
import api from "../../Api";
import { Link } from "react-router-dom";
import Deleteprofile from "../popup/Deleteprofile";
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const tools = [
  {
    name: "Redis",
    icon: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 4.375H6.5625C5.98234 4.375 5.42594 4.60547 5.0157 5.0157C4.60547 5.42594 4.375 5.98234 4.375 6.5625V22.6042C4.375 23.1843 4.60547 23.7407 5.0157 24.151C5.42594 24.5612 5.98234 24.7917 6.5625 24.7917H28.4375C29.0177 24.7917 29.5741 24.5612 29.9843 24.151C30.3945 23.7407 30.625 23.1843 30.625 22.6042V18.9583M17.5 24.7917V30.625M10.2083 30.625H24.7917"
          stroke="#666666"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.979 11.6665C28.1871 11.6665 29.1665 10.6871 29.1665 9.479C29.1665 8.27088 28.1871 7.2915 26.979 7.2915C25.7709 7.2915 24.7915 8.27088 24.7915 9.479C24.7915 10.6871 25.7709 11.6665 26.979 11.6665Z"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M26.9793 14.5833V11.6667M26.9793 7.29167V4.375M22.5591 12.0312L25.0849 10.5729M28.8737 8.38542L31.3995 6.92708M22.5591 6.92708L25.0849 8.38542M28.8737 10.5729L31.3995 12.0312"
          stroke="#666666"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Kafka",
    icon: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 4.375H6.5625C5.98234 4.375 5.42594 4.60547 5.0157 5.0157C4.60547 5.42594 4.375 5.98234 4.375 6.5625V22.6042C4.375 23.1843 4.60547 23.7407 5.0157 24.151C5.42594 24.5612 5.98234 24.7917 6.5625 24.7917H28.4375C29.0177 24.7917 29.5741 24.5612 29.9843 24.151C30.3945 23.7407 30.625 23.1843 30.625 22.6042V18.9583M17.5 24.7917V30.625M10.2083 30.625H24.7917"
          stroke="#666666"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.979 11.6665C28.1871 11.6665 29.1665 10.6871 29.1665 9.479C29.1665 8.27088 28.1871 7.2915 26.979 7.2915C25.7709 7.2915 24.7915 8.27088 24.7915 9.479C24.7915 10.6871 25.7709 11.6665 26.979 11.6665Z"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M26.9793 14.5833V11.6667M26.9793 7.29167V4.375M22.5591 12.0312L25.0849 10.5729M28.8737 8.38542L31.3995 6.92708M22.5591 6.92708L25.0849 8.38542M28.8737 10.5729L31.3995 12.0312"
          stroke="#666666"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Kubernetes",
    icon: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_585_748)">
          <path
            d="M11.2226 34.4287C10.4097 34.4287 9.64203 34.0573 9.12264 33.384L1.21961 23.2853C0.700215 22.612 0.497051 21.7532 0.700215 20.9172L3.52277 8.31135C3.70338 7.47556 4.24533 6.80227 4.99059 6.43091L16.4163 0.812634C16.7777 0.627091 17.1841 0.53418 17.5906 0.53418C17.9971 0.53418 18.4034 0.626951 18.7647 0.812774L30.1906 6.40771C30.9357 6.77908 31.4777 7.45237 31.6583 8.28816L34.4808 20.8941C34.6616 21.7298 34.4808 22.5888 33.9616 23.2621L26.0583 33.3608C25.5389 34.0108 24.7712 34.4055 23.9583 34.4055L11.2226 34.4287Z"
            fill="#326DE6"
          />
          <path
            d="M17.5677 1.11413C17.884 1.11413 18.2001 1.18371 18.4936 1.32301L29.9195 6.91795C30.5065 7.21974 30.9581 7.77693 31.0936 8.42703L33.9162 21.0329C34.0742 21.7062 33.9162 22.4027 33.4871 22.9366L25.584 33.0354C25.1775 33.5693 24.5452 33.871 23.8904 33.871H11.2226C10.5677 33.871 9.93555 33.5693 9.52909 33.0354L1.62593 22.9366C1.21946 22.4027 1.06128 21.7062 1.1969 21.0329L4.01946 8.42703C4.17751 7.75373 4.60653 7.19654 5.1936 6.91795L16.6196 1.29996C16.9131 1.18385 17.2518 1.11427 17.5679 1.11427M17.5679 0.0230898C17.0937 0.0230898 16.6196 0.139194 16.1679 0.34807L4.74216 5.96634C3.83886 6.40743 3.20667 7.21988 2.98081 8.21815L0.158114 20.8241C-0.0676087 21.8223 0.158114 22.8438 0.790438 23.6564L8.6936 33.7551C9.30337 34.5443 10.2291 34.9854 11.2001 34.9854H23.8677C24.8387 34.9854 25.7646 34.5443 26.3742 33.7551L34.2775 23.6562C34.9097 22.867 35.1356 21.8223 34.9097 20.8239L32.0871 8.21801C31.8614 7.21974 31.2291 6.40729 30.3259 5.9662L18.9452 0.347789C18.5162 0.139054 18.042 0.0229492 17.5677 0.0229492"
            fill="white"
          />
          <path
            d="M29.016 20.0351C28.9934 20.0351 28.9934 20.0351 29.016 20.0351H28.9934C28.9709 20.0351 28.9483 20.0351 28.9483 20.0119C28.9032 20.0119 28.8581 19.9887 28.8128 19.9887C28.6548 19.9655 28.5193 19.9423 28.3838 19.9423C28.316 19.9423 28.2483 19.9423 28.1579 19.919H28.1354C27.6612 19.8726 27.2773 19.8262 26.916 19.7101C26.7579 19.6404 26.7128 19.5476 26.6676 19.4547C26.6676 19.4315 26.645 19.4315 26.645 19.4083L26.3515 19.3155C26.4902 18.2234 26.4367 17.1146 26.1934 16.042C25.947 14.9604 25.5191 13.9313 24.9289 13.0008L25.1548 12.7919V12.7455C25.1548 12.6294 25.1773 12.5133 25.2676 12.3972C25.5385 12.1418 25.8773 11.9329 26.2838 11.6775C26.3515 11.6311 26.4191 11.6079 26.4869 11.5614C26.6224 11.4918 26.7354 11.4223 26.8709 11.3293C26.8934 11.3061 26.9385 11.283 26.9838 11.2366C27.0063 11.2132 27.0289 11.2132 27.0289 11.19C27.345 10.9115 27.4128 10.4472 27.1869 10.1452C27.074 9.98276 26.8709 9.88999 26.6676 9.88999C26.4871 9.88999 26.3289 9.95956 26.1709 10.0757L26.1257 10.1221C26.0806 10.1452 26.0579 10.1918 26.0128 10.215C25.8999 10.3311 25.8095 10.4238 25.7193 10.5399C25.6742 10.5863 25.629 10.656 25.5612 10.7024C25.245 11.0507 24.9515 11.3293 24.6579 11.5382C24.5903 11.5846 24.5226 11.6078 24.4548 11.6079C24.4096 11.6079 24.3644 11.6079 24.3193 11.5846H24.2742L24.003 11.7704C23.7095 11.4454 23.3934 11.1669 23.0773 10.8883C21.7162 9.79443 20.0781 9.12559 18.3579 8.96129L18.3354 8.6595L18.2903 8.61312C18.2224 8.5434 18.1322 8.47382 18.1095 8.31133C18.0869 7.93982 18.1322 7.52193 18.1773 7.05766V7.03446C18.1773 6.96474 18.1999 6.87197 18.2224 6.80225C18.245 6.6631 18.2676 6.52366 18.2903 6.36117V6.15229C18.2903 5.7344 17.974 5.38623 17.5903 5.38623C17.4095 5.38623 17.2289 5.479 17.0934 5.6183C16.9581 5.7576 16.8903 5.94328 16.8903 6.15229V6.33798C16.8903 6.50047 16.9128 6.63976 16.9579 6.77906C16.9805 6.84878 16.9805 6.91836 17.003 7.01127V7.03446C17.0482 7.49874 17.116 7.91663 17.0709 8.28814C17.0483 8.45063 16.9579 8.52021 16.8903 8.58993L16.8451 8.63631L16.8224 8.9381C16.416 8.98448 16.0095 9.03087 15.603 9.12378C13.8644 9.51848 12.3289 10.424 11.1322 11.7239L10.9063 11.5614H10.8612C10.8161 11.5614 10.7709 11.5846 10.7257 11.5846C10.658 11.5846 10.5902 11.5614 10.5224 11.515C10.2289 11.3061 9.93537 11.0042 9.61927 10.656C9.57416 10.6097 9.52904 10.5399 9.46123 10.4936C9.37086 10.3775 9.28048 10.2845 9.16755 10.1686C9.145 10.1452 9.09988 10.1222 9.05476 10.0757C9.0322 10.0525 9.00964 10.0525 9.00964 10.0293C8.86975 9.91043 8.69428 9.8448 8.51281 9.84346C8.30951 9.84346 8.10634 9.93637 7.99341 10.0989C7.76755 10.4006 7.83537 10.8649 8.15146 11.1435C8.17402 11.1435 8.17402 11.1669 8.19658 11.1669C8.2417 11.19 8.26439 11.2364 8.30951 11.2596C8.445 11.3524 8.55793 11.4221 8.69341 11.4918C8.76123 11.515 8.8289 11.5614 8.89671 11.6079C9.30304 11.8632 9.64183 12.0722 9.91281 12.3276C10.0257 12.4436 10.0257 12.5597 10.0257 12.6758V12.7222L10.2515 12.9312C10.2063 13.0008 10.1612 13.0473 10.1385 13.1169C9.00951 14.9509 8.58048 17.11 8.87402 19.2458L8.58048 19.3386C8.58048 19.3619 8.55793 19.3619 8.55793 19.385C8.51281 19.4779 8.445 19.5708 8.30951 19.6404C7.97086 19.7565 7.56439 19.803 7.09025 19.8494H7.06755C6.99988 19.8494 6.90951 19.8494 6.84183 19.8726C6.70634 19.8726 6.57086 19.8958 6.41281 19.919C6.36769 19.919 6.32257 19.9423 6.27732 19.9423C6.25476 19.9423 6.2322 19.9423 6.20951 19.9655C5.80304 20.0583 5.55463 20.453 5.62244 20.8243C5.69025 21.1494 5.98379 21.3585 6.345 21.3585C6.41281 21.3585 6.45793 21.3585 6.52574 21.3351C6.5483 21.3351 6.57086 21.3351 6.57086 21.3119C6.61597 21.3119 6.66109 21.2887 6.70621 21.2887C6.86439 21.2424 6.97732 21.196 7.11281 21.1263C7.18048 21.1031 7.24816 21.0565 7.31597 21.0335H7.33853C7.76755 20.8708 8.15146 20.7316 8.51281 20.6852H8.55793C8.69341 20.6852 8.78378 20.7547 8.85146 20.8013C8.87402 20.8013 8.87402 20.8245 8.89658 20.8245L9.21281 20.7781C9.75476 22.4959 10.7934 24.0282 12.1709 25.1425C12.4869 25.3978 12.803 25.6068 13.1418 25.8158L13.0063 26.1175C13.0063 26.1408 13.0289 26.1408 13.0289 26.1639C13.074 26.2568 13.1191 26.3729 13.074 26.5354C12.9387 26.8837 12.7354 27.2319 12.4869 27.6266V27.6497C12.4418 27.7195 12.3967 27.7658 12.3516 27.8354C12.2612 27.9515 12.1934 28.0676 12.103 28.2069C12.0805 28.2301 12.0579 28.2765 12.0354 28.323C12.0354 28.3462 12.0128 28.3694 12.0128 28.3694C11.8322 28.7641 11.9677 29.2052 12.3063 29.3677C12.3966 29.4142 12.4869 29.4374 12.5773 29.4374C12.8483 29.4374 13.1193 29.2516 13.2548 28.9962C13.2548 28.973 13.2773 28.9498 13.2773 28.9498C13.2999 28.9034 13.3224 28.857 13.345 28.8337C13.4128 28.6712 13.4354 28.5551 13.4805 28.4158L13.5483 28.2069C13.7063 27.7427 13.8193 27.3712 14.0224 27.0462C14.1127 26.9069 14.2257 26.8837 14.316 26.8372C14.3385 26.8372 14.3385 26.8372 14.3611 26.814L14.5193 26.5122C15.5128 26.9069 16.5967 27.1157 17.6805 27.1157C18.3354 27.1157 19.0128 27.0462 19.6451 26.8837C20.0431 26.7923 20.4352 26.676 20.8193 26.5354L20.9546 26.7908C20.9773 26.7908 20.9773 26.7908 20.9999 26.814C21.1128 26.8372 21.203 26.8837 21.2934 27.023C21.474 27.348 21.6095 27.7427 21.7676 28.1837V28.2069L21.8354 28.4158C21.8805 28.5551 21.903 28.6944 21.9707 28.8337C21.9934 28.8801 22.016 28.9034 22.0385 28.9498C22.0385 28.973 22.0612 28.9962 22.0612 28.9962C22.1966 29.2748 22.4676 29.4374 22.7385 29.4374C22.8289 29.4374 22.9193 29.4142 23.0095 29.3677C23.1676 29.2749 23.303 29.1355 23.3483 28.9498C23.3934 28.7641 23.3934 28.5551 23.3032 28.3694C23.3032 28.3462 23.2805 28.3462 23.2805 28.323C23.2579 28.2767 23.2354 28.2303 23.2128 28.2069C23.145 28.0676 23.0548 27.9515 22.9644 27.8354C22.9193 27.7658 22.8742 27.7195 22.829 27.6499V27.6266C22.5805 27.2319 22.3546 26.8837 22.2418 26.5354C22.1967 26.3729 22.2418 26.2801 22.2644 26.164C22.2644 26.1408 22.287 26.1408 22.287 26.1176L22.174 25.839C23.3709 25.1193 24.3869 24.0977 25.1548 22.8442C25.5612 22.1941 25.8773 21.4744 26.103 20.7547L26.374 20.8011C26.3967 20.8011 26.3967 20.7779 26.4191 20.7779C26.5095 20.7316 26.5773 20.662 26.7128 20.662H26.7579C27.1193 20.7084 27.503 20.8475 27.9322 21.0101H27.9548C28.0224 21.0333 28.0901 21.0797 28.1579 21.1029C28.2934 21.1726 28.4063 21.219 28.5644 21.2655C28.6095 21.2655 28.6546 21.2887 28.6999 21.2887C28.7224 21.2887 28.745 21.2887 28.7676 21.3119C28.8354 21.3351 28.8805 21.3351 28.9483 21.3351C29.2869 21.3351 29.5805 21.1031 29.6709 20.8013C29.6709 20.5227 29.4224 20.1512 29.016 20.0352M18.5611 18.8976L17.5676 19.3852L16.574 18.8976L16.3257 17.8066L17.003 16.9244H18.1095L18.787 17.8066L18.5611 18.8976ZM24.4548 16.4833C24.6299 17.251 24.6832 18.0427 24.6128 18.8279L21.1579 17.8066C20.8418 17.7138 20.6612 17.3887 20.7289 17.0637C20.7515 16.9708 20.7967 16.8779 20.8644 16.8083L23.5967 14.2778C23.9805 14.9279 24.274 15.6709 24.4548 16.4833ZM22.5128 12.8848L19.5548 15.0438C19.3063 15.2063 18.9676 15.1598 18.7644 14.9045C18.6967 14.8348 18.6742 14.7419 18.6515 14.6491L18.4483 10.8649C19.9861 11.047 21.4187 11.7589 22.5128 12.8848ZM15.9644 10.9809C16.2128 10.9345 16.4385 10.8881 16.6869 10.8417L16.4838 14.5561C16.4612 14.8811 16.2128 15.1597 15.874 15.1597C15.7838 15.1597 15.6709 15.1365 15.603 15.0901L12.5999 12.8848C13.5257 11.9329 14.6773 11.2827 15.9644 10.9809ZM11.516 14.2776L14.203 16.7385C14.4515 16.9475 14.474 17.342 14.2709 17.5974C14.203 17.6902 14.1128 17.7599 13.9999 17.7833L10.4999 18.8279C10.3644 17.2493 10.703 15.6474 11.516 14.2776ZM10.9062 20.5691L14.4967 19.9422C14.7902 19.919 15.0612 20.128 15.1289 20.4298C15.1515 20.5689 15.1515 20.6852 15.1063 20.8013L13.7289 24.2138C12.4644 23.3781 11.4482 22.1012 10.9062 20.5691ZM19.1484 25.1889C18.629 25.305 18.1096 25.3746 17.5677 25.3746C16.7775 25.3746 16.0096 25.2354 15.2872 25.0032L17.071 21.6834C17.2516 21.4744 17.5451 21.3817 17.7936 21.5209C17.8991 21.5872 17.9911 21.6739 18.0645 21.7762L19.8032 25.0032C19.6 25.0728 19.3743 25.1193 19.1484 25.1889ZM23.5515 21.962C22.9869 22.8906 22.2417 23.6335 21.3838 24.2138L19.9612 20.7082C19.8934 20.4298 20.0063 20.128 20.2773 19.9885C20.3676 19.9422 20.4805 19.919 20.5934 19.919L24.2063 20.5459C24.0709 21.0565 23.845 21.5209 23.5515 21.962Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_585_748">
            <rect width="35" height="35" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: "AWS",
    icon: (
      <svg
        width="35"
        height="24"
        viewBox="0 0 35 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_585_752)">
          <path
            d="M34.2729 9.14556C33.485 8.62664 31.6793 8.43204 30.2676 8.6915C30.1036 7.39421 29.3485 6.2592 28.0352 5.25379L27.2802 4.73488L26.7548 5.48082C26.0983 6.45379 25.77 7.81596 25.8684 9.11325C25.9012 9.56718 26.0654 10.378 26.5578 11.0915C26.0983 11.351 25.1462 11.6753 23.8987 11.6753H0.162712L0.0971053 11.9347C-0.132792 13.2319 -0.132792 17.2858 2.55928 20.3992C4.59473 22.7667 7.6151 23.9667 11.5875 23.9667C20.1888 23.9667 26.5578 20.0423 29.5454 12.94C30.7273 12.9725 33.2552 12.94 34.5356 10.5076C34.5684 10.4427 34.6341 10.313 34.8638 9.82664L34.9952 9.56718L34.2729 9.14556ZM19.1383 0H15.5272V3.24311H19.1383V0ZM19.1383 3.89176H15.5272V7.13488H19.1383V3.89176ZM14.8704 3.89176H11.2593V7.13488H14.8704V3.89176ZM10.6025 3.89176H6.99129V7.13488H10.6025V3.89176ZM6.33468 7.78352H2.72343V11.0266H6.33454L6.33468 7.78352ZM10.6025 7.78352H6.99129V11.0266H10.6025V7.78352ZM14.8704 7.78352H11.2593V11.0266H14.8704V7.78352ZM19.1384 7.78352H15.527V11.0266H19.1384V7.78352ZM23.4063 7.78352H19.7949V11.0266H23.4063V7.78352Z"
            fill="#2396ED"
          />
        </g>
        <defs>
          <clipPath id="clip0_585_752">
            <rect width="35" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: "Docker",
    icon: (
      <svg
        width="35"
        height="24"
        viewBox="0 0 35 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_585_752)">
          <path
            d="M34.2729 9.14556C33.485 8.62664 31.6793 8.43204 30.2676 8.6915C30.1036 7.39421 29.3485 6.2592 28.0352 5.25379L27.2802 4.73488L26.7548 5.48082C26.0983 6.45379 25.77 7.81596 25.8684 9.11325C25.9012 9.56718 26.0654 10.378 26.5578 11.0915C26.0983 11.351 25.1462 11.6753 23.8987 11.6753H0.162712L0.0971053 11.9347C-0.132792 13.2319 -0.132792 17.2858 2.55928 20.3992C4.59473 22.7667 7.6151 23.9667 11.5875 23.9667C20.1888 23.9667 26.5578 20.0423 29.5454 12.94C30.7273 12.9725 33.2552 12.94 34.5356 10.5076C34.5684 10.4427 34.6341 10.313 34.8638 9.82664L34.9952 9.56718L34.2729 9.14556ZM19.1383 0H15.5272V3.24311H19.1383V0ZM19.1383 3.89176H15.5272V7.13488H19.1383V3.89176ZM14.8704 3.89176H11.2593V7.13488H14.8704V3.89176ZM10.6025 3.89176H6.99129V7.13488H10.6025V3.89176ZM6.33468 7.78352H2.72343V11.0266H6.33454L6.33468 7.78352ZM10.6025 7.78352H6.99129V11.0266H10.6025V7.78352ZM14.8704 7.78352H11.2593V11.0266H14.8704V7.78352ZM19.1384 7.78352H15.527V11.0266H19.1384V7.78352ZM23.4063 7.78352H19.7949V11.0266H23.4063V7.78352Z"
            fill="#2396ED"
          />
        </g>
        <defs>
          <clipPath id="clip0_585_752">
            <rect width="35" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: "Zoho",
    icon: (
      <svg
        width="56"
        height="19"
        viewBox="0 0 56 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_585_771)">
          <path
            d="M55.9975 4.04688V17.0785L54.1602 18.839V6.08642L55.9975 4.04688Z"
            fill="#E79225"
          />
          <path
            d="M43.9562 4.05761L42.0532 6.08642L42.1517 6.21524L54.0834 6.1723L54.1928 6.08642L55.9973 4.04688L43.9562 4.05761Z"
            fill="#FFF16D"
          />
          <path
            d="M42.0532 6.08643H54.1928V18.8497H42.0532V6.08643Z"
            fill="url(#paint0_linear_585_771)"
          />
          <path
            d="M52.3445 10.681C52.1039 10.0906 51.743 9.55386 51.2727 9.09228C50.8243 8.64143 50.3212 8.29793 49.7525 8.07251C49.1948 7.84708 48.5933 7.729 47.9371 7.729C47.2809 7.729 46.6684 7.84708 46.1107 8.07251C45.542 8.29793 45.0389 8.64143 44.5905 9.09228C44.1202 9.55386 43.7703 10.0906 43.5297 10.681C43.2891 11.2714 43.1797 11.9154 43.1797 12.6239C43.1797 13.3109 43.3 13.955 43.5406 14.5561C43.7812 15.1573 44.1312 15.694 44.6014 16.1663C45.0389 16.6064 45.542 16.9392 46.0997 17.1646C46.6575 17.39 47.2809 17.5081 47.948 17.5081C48.5933 17.5081 49.1948 17.39 49.7525 17.1646C50.3103 16.9392 50.8243 16.6064 51.2727 16.1663C51.743 15.694 52.1039 15.1573 52.3445 14.5669C52.5851 13.9765 52.7054 13.3217 52.7054 12.6347C52.7054 11.9154 52.5851 11.2714 52.3445 10.681ZM49.84 14.8889C49.3698 15.4363 48.7464 15.7154 47.9371 15.7154C47.1278 15.7154 46.4935 15.4363 46.0232 14.8889C45.5529 14.3414 45.3232 13.5793 45.3232 12.6132C45.3232 11.6256 45.5638 10.8635 46.0232 10.3053C46.4935 9.74708 47.1168 9.47872 47.9371 9.47872C48.7464 9.47872 49.3698 9.75782 49.84 10.3053C50.2994 10.8635 50.54 11.6256 50.54 12.6132C50.54 13.5793 50.3103 14.3414 49.84 14.8889Z"
            fill="white"
          />
          <path
            d="M40.8613 2.98438V3.04878L42.4143 14.7601L41.5066 17.229L41.3863 17.1431L39.7896 5.91488L39.8224 5.7646L40.8176 3.04878L40.8613 2.98438Z"
            fill="#009ADA"
          />
          <path
            d="M28.908 4.61601L40.8616 2.98438L39.8554 5.7968L39.7133 5.94709L28.5361 7.55726L28.5908 5.54991L28.908 4.61601Z"
            fill="#91C9ED"
          />
          <path
            d="M39.8551 5.79639L41.5065 17.2286L29.7279 18.8495L28.1421 7.80373L28.8311 7.27774L39.8551 5.79639Z"
            fill="url(#paint1_linear_585_771)"
          />
          <path
            d="M37.8538 7.98657C37.7991 7.63233 37.6788 7.36397 37.482 7.18149C37.3179 7.04194 37.1211 6.9668 36.8914 6.9668C36.8367 6.9668 36.7711 6.9668 36.7055 6.97753C36.3993 7.02047 36.1696 7.16002 36.0274 7.38544C35.9181 7.54646 35.8743 7.75041 35.8743 7.98657C35.8743 8.07245 35.8853 8.16906 35.8962 8.26567L36.3227 11.2391L32.9324 11.7329L32.5059 8.75945C32.4512 8.41595 32.3309 8.14759 32.134 7.9651C31.97 7.81482 31.7731 7.73968 31.5544 7.73968C31.4997 7.73968 31.445 7.73968 31.3904 7.75041C31.0732 7.79335 30.8326 7.9329 30.6795 8.15832C30.5701 8.31934 30.5264 8.52329 30.5264 8.75945C30.5264 8.84533 30.5373 8.94194 30.5482 9.04928L31.7075 16.7888C31.7622 17.1431 31.8825 17.4114 32.1012 17.5939C32.2653 17.7335 32.4621 17.7979 32.7027 17.7979C32.7684 17.7979 32.834 17.7979 32.8996 17.7871C33.1949 17.7442 33.4136 17.6046 33.5558 17.3792C33.6542 17.2182 33.698 17.025 33.698 16.7996C33.698 16.7137 33.687 16.6171 33.6761 16.5205L33.2058 13.4611L36.5961 12.9674L37.0664 16.0267C37.1211 16.3809 37.2414 16.6493 37.4492 16.821C37.6132 16.9606 37.8101 17.0357 38.0397 17.0357C38.0944 17.0357 38.1601 17.0357 38.2257 17.025C38.5319 16.9821 38.7616 16.8425 38.9037 16.6171C39.0022 16.4561 39.0568 16.2628 39.0568 16.0267C39.0568 15.9408 39.0459 15.8442 39.035 15.7476L37.8538 7.98657Z"
            fill="white"
          />
          <path
            d="M17.7196 0L13.4653 9.91864L14.045 14.2768L14.0778 14.2661L18.857 3.71412L18.8352 3.4887L17.8071 0.139548L17.7196 0Z"
            fill="#66BF6B"
          />
          <path
            d="M17.7197 0L18.8243 3.63898L18.8462 3.71412L29.3671 8.34068L29.3999 8.31921L28.5031 4.84124L17.7197 0Z"
            fill="#98D0A0"
          />
          <path
            d="M18.8242 3.63916L29.3998 8.31939L24.6205 18.9572L14.0449 14.277L18.8242 3.63916Z"
            fill="url(#paint2_linear_585_771)"
          />
          <path
            d="M26.1954 9.17807C25.9658 8.57694 25.6486 8.06168 25.233 7.6323C24.8174 7.20293 24.3144 6.85942 23.7238 6.61253C23.1332 6.36564 22.5427 6.24756 21.9411 6.24756H21.9083C21.2959 6.24756 20.6944 6.38711 20.1038 6.64473C19.4804 6.9131 18.9445 7.27807 18.4852 7.76112C18.0259 8.23343 17.654 8.8131 17.3697 9.47863C17.0853 10.1334 16.9322 10.799 16.8994 11.4538V11.6792C16.8994 12.2589 16.9978 12.8278 17.2056 13.386C17.4244 13.9764 17.7415 14.4809 18.1571 14.9103C18.5727 15.3396 19.0867 15.6832 19.6992 15.93C20.2788 16.1769 20.8694 16.295 21.4709 16.295H21.4818C22.0833 16.295 22.6848 16.1662 23.2754 15.9193C23.8988 15.6509 24.4456 15.2752 24.9049 14.7922C25.3643 14.3199 25.7471 13.7509 26.0314 13.0854C26.3158 12.4199 26.4689 11.7651 26.5017 11.1103V10.917C26.5126 10.3267 26.4142 9.74699 26.1954 9.17807ZM24.0847 12.2696C23.691 13.1928 23.1551 13.8261 22.5098 14.1696C22.1599 14.3521 21.799 14.4487 21.4381 14.4487C21.1209 14.4487 20.7819 14.3735 20.4428 14.234C19.6992 13.9227 19.2398 13.4289 19.043 12.7204C18.9774 12.4843 18.9445 12.2374 18.9445 11.9798C18.9445 11.4645 19.0758 10.8956 19.3383 10.2837C19.7429 9.33908 20.2788 8.69502 20.9241 8.34078C21.274 8.14756 21.6349 8.06168 21.9958 8.06168C22.3239 8.06168 22.652 8.13682 23.002 8.27637C23.7347 8.58767 24.1941 9.08146 24.3909 9.78993C24.4565 10.0154 24.4894 10.2622 24.4894 10.5199C24.4894 11.0566 24.3581 11.6363 24.0847 12.2696Z"
            fill="white"
          />
          <path
            d="M12.6231 1.68555L14.351 13.0426L13.5636 17.0358L13.4542 16.8963L11.77 5.92566V5.71097L12.5137 1.87877L12.6231 1.68555Z"
            fill="#760D16"
          />
          <path
            d="M0.00244141 7.5573L0.82268 3.54261L12.6232 1.68555L11.8248 5.77538V6.04374L0.144616 7.66464L0.00244141 7.5573Z"
            fill="#EF463E"
          />
          <path
            d="M11.8248 5.7749L13.5637 17.0354L1.88352 18.828L0.00244141 7.55682L11.8248 5.7749Z"
            fill="url(#paint3_linear_585_771)"
          />
          <path
            d="M10.5674 15.2427C10.4799 15.1354 10.3486 15.0602 10.1955 15.0066C10.0424 14.9529 9.8565 14.9314 9.62683 14.9314C9.41904 14.9314 9.17843 14.9529 8.91596 14.9958L5.83186 15.5111C5.86467 15.2749 5.98497 14.9744 6.19276 14.5987C6.42243 14.18 6.7724 13.6755 7.2208 13.0958C7.37391 12.8919 7.49421 12.7416 7.5817 12.6343C7.63638 12.5591 7.72388 12.4625 7.83324 12.323C8.54411 11.4105 8.97064 10.6698 9.14562 10.0902C9.24405 9.75742 9.29873 9.42465 9.32061 9.09188C9.33154 8.99527 9.33154 8.90939 9.33154 8.82352C9.33154 8.58736 9.30967 8.3512 9.26592 8.11504C9.23311 7.90035 9.17843 7.7286 9.10188 7.58905C9.02532 7.44951 8.93783 7.34216 8.82846 7.27775C8.70816 7.20261 8.52224 7.17041 8.29257 7.17041C8.10665 7.17041 7.87699 7.19188 7.60357 7.23482L4.03827 7.83595C3.61175 7.91109 3.28365 8.02917 3.08679 8.22239C2.92275 8.37267 2.84619 8.56589 2.84619 8.78058C2.84619 8.83425 2.84619 8.89866 2.85713 8.96307C2.91181 9.26363 3.06492 9.47832 3.31646 9.58566C3.46957 9.65007 3.64456 9.68227 3.86329 9.68227C4.00546 9.68227 4.16951 9.67154 4.34449 9.63934L7.31923 9.12408C7.31923 9.17775 7.33016 9.23143 7.33016 9.27436C7.33016 9.45685 7.29735 9.63934 7.23173 9.81109C7.14424 10.058 6.92551 10.4015 6.56461 10.8416C6.46618 10.9597 6.31307 11.1529 6.10527 11.3998C5.29597 12.3552 4.72727 13.171 4.3773 13.8472C4.12576 14.3196 3.96172 14.7704 3.86329 15.232C3.8086 15.5004 3.77579 15.7472 3.77579 15.9941C3.77579 16.1659 3.78673 16.3376 3.81954 16.4987C3.86329 16.7348 3.91797 16.928 3.99453 17.0783C4.07108 17.2286 4.18045 17.3467 4.30075 17.4111C4.42105 17.4755 4.5851 17.497 4.8257 17.497C5.12099 17.497 5.52564 17.454 6.03965 17.3682L9.27686 16.8207C9.84556 16.7241 10.2502 16.5845 10.4799 16.402C10.6658 16.2518 10.7642 16.0478 10.7642 15.8117C10.7642 15.7472 10.7533 15.6828 10.7424 15.6184C10.7205 15.4789 10.6658 15.3501 10.5674 15.2427Z"
            fill="white"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_585_771"
            x1="648.981"
            y1="24.3507"
            x2="648.981"
            y2="1243.88"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00562" stop-color="#FFE513" />
            <stop offset="1" stop-color="#FDB924" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_585_771"
            x1="88.4423"
            y1="181.935"
            x2="1283.98"
            y2="1169.8"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00562" stop-color="#008CD2" />
            <stop offset="1" stop-color="#00649D" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_585_771"
            x1="781.819"
            y1="429.16"
            x2="781.819"
            y2="1497.6"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#26A146" />
            <stop offset="1" stop-color="#008A52" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_585_771"
            x1="593.091"
            y1="112.915"
            x2="766.929"
            y2="1224.4"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#D92231" />
            <stop offset="1" stop-color="#BA2234" />
          </linearGradient>
          <clipPath id="clip0_585_771">
            <rect width="56" height="19" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: "Git",
    icon: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_585_692)">
          <g clipPath="url(#clip1_585_692)">
            <path
              d="M34.1076 13.9629L19.0368 -1.10738C18.1695 -1.97527 16.7618 -1.97527 15.8931 -1.10738L12.7639 2.02238L16.7337 5.99215C17.6565 5.6807 18.7142 5.88961 19.4494 6.62488C20.1885 7.36481 20.3958 8.43148 20.0767 9.35734L23.9026 13.1836C24.8282 12.8645 25.8965 13.0706 26.6354 13.8111C27.669 14.8439 27.669 16.5181 26.6354 17.5514C26.3897 17.7972 26.0981 17.9921 25.7771 18.1251C25.4561 18.2581 25.1121 18.3266 24.7646 18.3266C24.4172 18.3266 24.0732 18.2581 23.7522 18.1251C23.4312 17.9921 23.1395 17.7972 22.8939 17.5514C22.525 17.1821 22.2735 16.712 22.1711 16.2001C22.0687 15.6882 22.1199 15.1574 22.3183 14.6746L18.7505 11.1068L18.75 20.4969C19.0089 20.6244 19.2452 20.7932 19.4497 20.9968C20.4827 22.0295 20.4827 23.7032 19.4497 24.7382C18.4164 25.771 16.7416 25.771 15.7094 24.7382C14.6763 23.7035 14.6763 22.0298 15.7094 20.9968C15.9571 20.7491 16.2514 20.5531 16.5753 20.4198V10.9427C16.251 10.81 15.9566 10.6138 15.7094 10.3655C14.9268 9.58348 14.7384 8.43504 15.1398 7.47363L11.2261 3.55992L0.892321 13.8931C0.475415 14.3102 0.241211 14.8757 0.241211 15.4654C0.241211 16.0551 0.475415 16.6206 0.892321 17.0377L15.9634 32.1079C16.8313 32.9758 18.2384 32.9758 19.1076 32.1079L34.1079 17.1077C34.5247 16.6905 34.7588 16.1249 34.7588 15.5352C34.7587 14.9455 34.5245 14.3799 34.1076 13.9629Z"
              fill="#F34F29"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_585_692">
            <rect width="35" height="35" fill="white" />
          </clipPath>
          <clipPath id="clip1_585_692">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="translate(0 -2)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: "React",
    icon: (
      <svg
        width="35"
        height="31"
        viewBox="0 0 35 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_585_808)">
          <path
            d="M28.7756 10.0374C28.4032 9.91039 28.0276 9.79265 27.6492 9.68435C27.7127 9.42602 27.7713 9.17081 27.8232 8.92009C28.676 4.80294 28.1185 1.48607 26.2143 0.394003C24.3886 -0.652927 21.4028 0.438735 18.3874 3.04885C18.0902 3.30654 17.7996 3.57167 17.5159 3.84398C17.326 3.66291 17.1327 3.48535 16.9361 3.3114C13.7758 0.520586 10.608 -0.655647 8.70591 0.439551C6.88185 1.48974 6.34172 4.60783 7.10946 8.50975C7.18584 8.89619 7.27209 9.28064 7.36811 9.66273C6.91971 9.78945 6.48704 9.92433 6.07296 10.0679C2.3677 11.3528 0.00146484 13.3663 0.00146484 15.4548C0.00146484 17.6119 2.54172 19.7755 6.40092 21.0875C6.7138 21.1934 7.02927 21.2915 7.34706 21.3818C7.24388 21.7934 7.15226 22.2077 7.07228 22.6243C6.34036 26.4585 6.91192 29.5029 8.73106 30.5464C10.6099 31.6241 13.7635 30.5165 16.834 27.8468C17.083 27.6298 17.3265 27.4066 17.5643 27.1775C17.8715 27.4723 18.187 27.7586 18.5103 28.0359C21.4847 30.5815 24.4222 31.6094 26.2396 30.563C28.1167 29.4822 28.7268 26.2117 27.9348 22.2327C27.8724 21.921 27.8024 21.6108 27.7249 21.3024C27.9464 21.2372 28.1637 21.17 28.3756 21.1001C32.3877 19.7781 34.998 17.6407 34.998 15.4548C34.998 13.3587 32.5554 11.3316 28.7756 10.0374ZM27.9055 19.6888C27.7139 19.7517 27.518 19.8126 27.3177 19.8717C26.8747 18.4771 26.2771 16.9942 25.5456 15.462C26.2436 13.9664 26.8183 12.5025 27.2488 11.117C27.6068 11.2201 27.9542 11.3287 28.2891 11.4433C31.5276 12.5523 33.503 14.1916 33.503 15.4548C33.503 16.8003 31.3696 18.5471 27.9055 19.6888ZM26.4682 22.5215C26.8184 24.2809 26.8683 25.8717 26.6363 27.1153C26.428 28.2328 26.0088 28.9778 25.4905 29.2762C24.3877 29.9112 22.0291 29.0859 19.4854 26.9088C19.1847 26.6509 18.8913 26.3848 18.6054 26.1107C19.5916 25.0381 20.5771 23.7911 21.539 22.4062C23.2309 22.2569 24.8292 22.0127 26.2787 21.6794C26.3502 21.9661 26.4134 22.2467 26.4682 22.5215ZM11.9326 29.1665C10.8551 29.5449 9.99682 29.5558 9.47802 29.2583C8.37412 28.6251 7.9152 26.1806 8.54118 22.9016C8.61559 22.5142 8.70079 22.1288 8.79668 21.7461C10.2302 22.0615 11.8169 22.2883 13.5127 22.4251C14.4812 23.7802 15.4951 25.0258 16.517 26.1165C16.2998 26.3255 16.0775 26.5292 15.8503 26.7273C14.4924 27.9077 13.1317 28.7453 11.9326 29.1665ZM6.88458 19.6805C5.17809 19.1003 3.76879 18.3464 2.80283 17.5237C1.93475 16.7844 1.49661 16.0504 1.49661 15.4548C1.49661 14.1874 3.39641 12.5707 6.5651 11.472C6.94965 11.3388 7.35211 11.213 7.76975 11.095C8.20775 12.5117 8.78219 13.9931 9.47542 15.491C8.77317 17.0111 8.19053 18.5161 7.74829 19.9496C7.45822 19.8669 7.17023 19.7772 6.88458 19.6805ZM8.57672 8.22409C7.91903 4.88112 8.35581 2.35938 9.45505 1.72646C10.6258 1.05234 13.2147 2.01348 15.9435 4.42332C16.1214 4.58082 16.2965 4.74151 16.4686 4.90532C15.4518 5.99127 14.4471 7.2276 13.4873 8.57474C11.8414 8.72648 10.2659 8.97013 8.81732 9.29658C8.72806 8.9412 8.64783 8.5835 8.57672 8.22409ZM23.6727 11.9317C23.3305 11.3439 22.9757 10.7635 22.6084 10.191C23.725 10.3314 24.7949 10.5178 25.7996 10.7457C25.498 11.7072 25.122 12.7124 24.6795 13.743C24.3561 13.1327 24.0204 12.5288 23.6727 11.9317ZM17.5166 5.96816C18.2061 6.7112 18.8967 7.54073 19.576 8.44081C18.198 8.37608 16.8178 8.37581 15.4397 8.44C16.1197 7.5482 16.8162 6.71977 17.5166 5.96816ZM11.3209 11.9418C10.9776 12.534 10.6482 13.1341 10.333 13.7417C9.89771 12.7147 9.52518 11.7049 9.22101 10.7298C10.2195 10.5076 11.2843 10.326 12.3938 10.1881C12.0225 10.7642 11.6647 11.349 11.3209 11.9418ZM12.4257 20.8272C11.2794 20.7 10.1986 20.5277 9.20037 20.3115C9.50933 19.319 9.89005 18.2877 10.3348 17.2387C10.6512 17.8467 10.982 18.4472 11.3268 19.0397C11.6814 19.6488 12.0486 20.2454 12.4257 20.8272ZM17.5579 25.0462C16.8492 24.2859 16.1424 23.4447 15.4522 22.54C16.1223 22.5661 16.8054 22.5794 17.4998 22.5794C18.2131 22.5794 18.9182 22.5635 19.6123 22.5328C18.9308 23.4538 18.2428 24.2962 17.5579 25.0462ZM24.6936 17.1851C25.1614 18.2457 25.5557 19.2715 25.8687 20.2471C24.8541 20.4774 23.7585 20.6628 22.6042 20.8006C22.9741 20.2174 23.3323 19.6269 23.6786 19.0295C24.0306 18.4223 24.3691 17.8073 24.6936 17.1851ZM22.3836 18.2866C21.8534 19.2025 21.2935 20.101 20.7047 20.9807C19.638 21.0559 18.5691 21.0932 17.4998 21.0926C16.4106 21.0926 15.3513 21.0589 14.3312 20.9931C13.727 20.1154 13.1564 19.2153 12.6206 18.2947C12.0873 17.379 11.5893 16.4435 11.1275 15.4902C11.5882 14.5366 12.0848 13.6007 12.6162 12.6843L12.6161 12.6844C13.1473 11.7677 13.7133 10.8715 14.313 9.99761C15.3538 9.9193 16.421 9.87851 17.4996 9.87851C18.5831 9.87851 19.6519 9.9197 20.6924 9.99856C21.286 10.8711 21.8484 11.7643 22.3786 12.6764C22.9118 13.5908 23.415 14.5222 23.8873 15.4691C23.4198 16.4257 22.9182 17.3654 22.3836 18.2866ZM25.4676 1.682C26.6395 2.35421 27.0952 5.06494 26.3589 8.61974C26.3117 8.84671 26.2593 9.0774 26.2017 9.3118C24.7497 8.97842 23.173 8.73056 21.5223 8.57651C20.5607 7.21455 19.5643 5.97631 18.564 4.90437C18.8262 4.65305 19.0946 4.40823 19.3689 4.17016C21.9527 1.93394 24.3674 1.05099 25.4676 1.682ZM17.4998 12.3467C19.2257 12.3467 20.6248 13.7383 20.6248 15.4548C20.6248 17.1714 19.2257 18.563 17.4998 18.563C15.7739 18.563 14.3747 17.1714 14.3747 15.4548C14.3747 13.7383 15.7739 12.3467 17.4998 12.3467Z"
            fill="#00D8FF"
          />
        </g>
        <defs>
          <clipPath id="clip0_585_808">
            <rect width="35" height="31" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: "Node.js",
    icon: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.4999 32.0616C17.0989 32.0616 16.7241 31.9537 16.3741 31.767L12.8172 29.6553C12.2849 29.3593 12.5518 29.2514 12.7122 29.1974C13.4356 28.9568 13.5697 28.9043 14.3179 28.4785C14.3995 28.4245 14.506 28.4493 14.5877 28.5033L17.3147 30.1366C17.4227 30.1891 17.5568 30.1891 17.637 30.1366L28.3106 23.9576C28.4185 23.9051 28.471 23.7972 28.471 23.6631V11.3285C28.471 11.1958 28.4185 11.0878 28.3106 11.0353L17.637 4.88264C17.5306 4.82868 17.3964 4.82868 17.3147 4.88264L6.63828 11.0339C6.53182 11.0864 6.47786 11.222 6.47786 11.327V23.6601C6.47786 23.7666 6.53182 23.9022 6.63828 23.9547L9.55495 25.642C11.1329 26.4412 12.1245 25.5035 12.1245 24.5701V12.3989C12.1245 12.2385 12.2572 12.0766 12.4454 12.0766H13.8104C13.9679 12.0766 14.1312 12.2108 14.1312 12.3989V24.5716C14.1312 26.6847 12.982 27.917 10.9754 27.917C10.3599 27.917 9.8787 27.917 8.5137 27.2462L5.70641 25.6435C5.36437 25.4446 5.0805 25.1595 4.88319 24.8166C4.68588 24.4737 4.58204 24.0849 4.58203 23.6893V11.3547C4.58203 10.5526 5.00932 9.80306 5.70641 9.40202L16.3756 3.22306C16.7219 3.03783 17.1086 2.94092 17.5014 2.94092C17.8942 2.94092 18.2809 3.03783 18.6272 3.22306L29.2979 9.40202C29.9964 9.8016 30.4222 10.5526 30.4222 11.3547V23.6893C30.4222 24.4899 29.9949 25.2395 29.2979 25.6435L18.6272 31.821C18.2758 31.9814 17.8747 32.0616 17.4999 32.0616ZM20.7899 23.5799C16.1087 23.5799 15.1462 21.4391 15.1462 19.622C15.1462 19.4616 15.2804 19.2997 15.467 19.2997H16.8583C17.0187 19.2997 17.1514 19.4062 17.1514 19.5681C17.3658 20.9841 17.9797 21.6812 20.8177 21.6812C23.0635 21.6812 24.0289 21.1708 24.0289 19.9676C24.0289 19.272 23.7591 18.7645 20.2562 18.4174C17.341 18.1258 15.5224 17.4797 15.5224 15.1537C15.5224 12.9881 17.341 11.7033 20.3918 11.7033C23.8145 11.7033 25.5004 12.8831 25.7133 15.4483C25.7107 15.5348 25.6823 15.6187 25.6316 15.6889C25.5777 15.7414 25.4989 15.7954 25.4187 15.7954H24.0289C23.9602 15.7939 23.894 15.7696 23.8406 15.7263C23.7873 15.683 23.7499 15.6231 23.7343 15.5562C23.412 14.0804 22.5837 13.602 20.3918 13.602C17.9287 13.602 17.6341 14.4581 17.6341 15.0997C17.6341 15.8741 17.9797 16.1147 21.3004 16.5435C24.5904 16.9708 26.142 17.5862 26.142 19.8889C26.1129 22.2441 24.1893 23.5799 20.7899 23.5799Z"
          fill="#666666"
        />
      </svg>
    ),
  },
  {
    name: "REST API",
    icon: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28 22.75C25.725 22.75 23.8 24.15 23.1 26.25H15.75C15.75 25.025 15.4 23.975 14.875 23.1L27.3 10.325C27.825 10.325 28.35 10.5 28.875 10.5C31.325 10.5 33.25 8.575 33.25 6.125C33.25 3.675 31.325 1.75 28.875 1.75C26.425 1.75 24.5 3.675 24.5 6.125C24.5 6.65 24.675 7.35 24.85 7.875L12.6 20.475C11.55 19.6 10.15 19.25 8.75 19.25V11.9C10.85 11.2 12.25 9.275 12.25 7C12.25 4.025 9.975 1.75 7 1.75C4.025 1.75 1.75 4.025 1.75 7C1.75 9.275 3.15 11.2 5.25 11.9V20.125C3.15 21.35 1.75 23.625 1.75 26.075C1.75 29.925 4.9 33.075 8.75 33.075C11.375 33.075 13.65 31.675 14.7 29.575H22.925C23.625 31.5 25.55 33.075 27.825 33.075C30.625 33.075 33.075 30.8 33.075 27.825C33.25 25.025 30.8 22.75 28 22.75Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: "Zapier",
    icon: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_585_802)">
          <path
            d="M21.875 17.5055C21.8749 18.7682 21.647 20.0205 21.2023 21.2023C20.0205 21.647 18.7682 21.8749 17.5055 21.875H17.4934C16.2307 21.8749 14.9784 21.647 13.7966 21.2023C13.3519 20.0205 13.124 18.7682 13.1239 17.5055V17.4934C13.1239 16.1897 13.3634 14.9472 13.7966 13.7966C14.9784 13.3519 16.2307 13.124 17.4934 13.1239H17.5055C18.8092 13.1239 20.0572 13.3634 21.2023 13.7966C21.647 14.9784 21.8749 16.2307 21.875 17.4934V17.5055ZM34.7605 14.583H24.5405L31.7581 7.35984C31.1929 6.56446 30.5622 5.81774 29.8725 5.1275C29.1825 4.43593 28.4358 3.80336 27.6402 3.23641L20.417 10.4541V0.239531C19.4547 0.0835075 18.4815 0.00341675 17.5066 0L17.4891 0C16.497 0 15.5291 0.0907812 14.5841 0.239531V10.4595L7.36641 3.24187C6.56541 3.80245 5.81613 4.4335 5.1275 5.1275C4.43399 5.81573 3.80127 6.56263 3.23641 7.35984L10.4541 14.583H0.239531C0.239531 14.583 0 16.5025 0 17.4934V17.5055C0 18.4975 0.0907812 19.4709 0.239531 20.4159H10.4595L3.24187 27.6336C4.37064 29.2336 5.76312 30.6302 7.35984 31.7636L14.583 24.5459V34.7605C15.528 34.9136 16.4959 35 17.488 35H17.5109C18.503 35 19.4709 34.9136 20.4159 34.7605V24.5459L27.6336 31.7636C28.4375 31.2167 29.1834 30.5791 29.8659 29.8834H29.8714C30.5683 29.1983 31.2013 28.4511 31.7625 27.6511L24.5448 20.4334H34.7594C34.9125 19.4928 34.9989 18.5303 34.9989 17.5448V17.5C34.9989 16.508 34.9125 15.54 34.7594 14.6005L34.7605 14.583Z"
            fill="#666666"
          />
        </g>
        <defs>
          <clipPath id="clip0_585_802">
            <rect width="35" height="35" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: "PHP",
    icon: (
      <svg
        width="46"
        height="24"
        viewBox="0 0 46 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_585_797)">
          <path
            d="M22.76 23.9289C35.3275 23.9289 45.5155 18.5722 45.5155 11.9644C45.5155 5.35667 35.3275 0 22.76 0C10.1924 0 0.00439453 5.35667 0.00439453 11.9644C0.00439453 18.5722 10.1924 23.9289 22.76 23.9289Z"
            fill="url(#paint0_radial_585_797)"
          />
          <path
            d="M22.7602 23.0398C34.8368 23.0398 44.6269 18.0811 44.6269 11.9642C44.6269 5.84737 34.8368 0.888672 22.7602 0.888672C10.6836 0.888672 0.893555 5.84737 0.893555 11.9642C0.893555 18.0811 10.6836 23.0398 22.7602 23.0398Z"
            fill="#6181B6"
          />
          <path
            d="M27.1865 15.5556L28.271 9.97335C28.5199 8.71113 28.3065 7.76891 27.6665 7.18224C27.0443 6.61335 25.9777 6.32891 24.4132 6.32891H22.5288L23.0621 3.55557C23.0799 3.44891 23.0621 3.34224 22.991 3.25335C22.9199 3.16446 22.831 3.12891 22.7243 3.12891H20.1288C19.951 3.12891 19.8088 3.25335 19.7732 3.41335L18.6177 9.33335C18.511 8.6578 18.2621 8.08891 17.8354 7.62668C17.071 6.75557 15.8799 6.31113 14.2621 6.31113H9.26654C9.08876 6.31113 8.94654 6.43557 8.91098 6.59557L6.5821 18.6134C6.56432 18.72 6.5821 18.8267 6.65321 18.9156C6.72432 19.0045 6.81321 19.04 6.91987 19.04H9.53321C9.71098 19.04 9.85321 18.9156 9.88876 18.7556L10.4577 15.8578H12.3954C13.4088 15.8578 14.2799 15.7511 14.9377 15.5378C15.631 15.3067 16.2532 14.9334 16.8043 14.4178C17.2488 14.0089 17.6221 13.5467 17.9065 13.0489L17.4443 15.4489C17.4265 15.5556 17.4443 15.6622 17.5154 15.7511C17.5865 15.84 17.6754 15.8756 17.7821 15.8756H20.3777C20.5554 15.8756 20.6977 15.7511 20.7332 15.5911L22.0132 9.01335H23.791C24.5554 9.01335 24.7688 9.15557 24.8399 9.22668C24.8932 9.28002 24.9999 9.49335 24.8754 10.1511L23.8443 15.4667C23.8265 15.5734 23.8443 15.68 23.9154 15.7689C23.9865 15.8578 24.0754 15.8934 24.1821 15.8934H26.8488C27.0088 15.84 27.151 15.7156 27.1865 15.5556ZM15.1688 10.9334C15.0088 11.7689 14.7065 12.3734 14.2621 12.7111C13.8177 13.0489 13.0888 13.2267 12.1288 13.2267H10.9732L11.8088 8.92446H13.3021C14.4043 8.92446 14.8488 9.15557 15.0265 9.35113C15.2577 9.63557 15.311 10.1867 15.1688 10.9334ZM38.2799 7.62668C37.5154 6.75557 36.3243 6.31113 34.7065 6.31113H29.6754C29.4977 6.31113 29.3554 6.43557 29.3199 6.59557L26.991 18.5956C26.9732 18.7022 26.991 18.8089 27.0621 18.8978C27.1332 18.9867 27.2221 19.0222 27.3288 19.0222H29.9421C30.1199 19.0222 30.2621 18.8978 30.2977 18.7378L30.8665 15.84H32.8043C33.8177 15.84 34.6888 15.7334 35.3465 15.52C36.0399 15.2889 36.6621 14.9156 37.2132 14.4C37.6754 13.9734 38.0665 13.4934 38.351 12.9778C38.6354 12.4622 38.8488 11.8934 38.9732 11.2711C39.2754 9.72446 39.0443 8.51557 38.2799 7.62668ZM35.5599 10.9334C35.3999 11.7689 35.0977 12.3734 34.6532 12.7111C34.2088 13.0489 33.4799 13.2267 32.5199 13.2267H31.3643L32.1999 8.92446H33.6932C34.7954 8.92446 35.2399 9.15557 35.4177 9.35113C35.6665 9.63557 35.7199 10.1867 35.5599 10.9334Z"
            fill="white"
          />
          <path
            d="M13.3024 8.56882C14.298 8.56882 14.9558 8.7466 15.2935 9.11993C15.6313 9.49326 15.7024 10.1155 15.5247 11.0044C15.3469 11.9288 14.9913 12.6044 14.4758 12.9955C13.9602 13.3866 13.178 13.5822 12.1291 13.5822H10.5469L11.5247 8.56882H13.3024ZM6.93799 18.6666H9.55132L10.1735 15.4844H12.4135C13.4091 15.4844 14.2091 15.3777 14.8491 15.1644C15.4891 14.951 16.058 14.6133 16.5913 14.1155C17.0358 13.7066 17.3913 13.2622 17.658 12.7822C17.9247 12.3022 18.1202 11.7688 18.2269 11.1822C18.5113 9.75993 18.298 8.65771 17.6047 7.85771C16.9113 7.05771 15.8091 6.6666 14.298 6.6666H9.26688L6.93799 18.6666ZM20.1469 3.48438H22.7424L22.1202 6.6666H24.4313C25.8891 6.6666 26.8847 6.91549 27.4358 7.43104C27.9869 7.9466 28.1469 8.76437 27.9335 9.90215L26.8491 15.4844H24.218L25.2491 10.1688C25.3735 9.56437 25.3202 9.15549 25.1247 8.94215C24.9291 8.72882 24.4847 8.60438 23.8269 8.60438H21.7469L20.4135 15.4844H17.818L20.1469 3.48438ZM33.6935 8.56882C34.6891 8.56882 35.3469 8.7466 35.6847 9.11993C36.0224 9.49326 36.0935 10.1155 35.9158 11.0044C35.738 11.9288 35.3824 12.6044 34.8669 12.9955C34.3513 13.3866 33.5691 13.5822 32.5202 13.5822H30.938L31.9158 8.56882H33.6935ZM27.3291 18.6666H29.9424L30.5647 15.4844H32.8047C33.8002 15.4844 34.6002 15.3777 35.2402 15.1644C35.8802 14.951 36.4491 14.6133 36.9824 14.1155C37.4269 13.7066 37.7824 13.2622 38.0491 12.7822C38.3158 12.3022 38.5113 11.7688 38.618 11.1822C38.9024 9.75993 38.6891 8.65771 37.9958 7.85771C37.3024 7.05771 36.2002 6.6666 34.6891 6.6666H29.658L27.3291 18.6666Z"
            fill="#000004"
          />
        </g>
        <defs>
          <radialGradient
            id="paint0_radial_585_797"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(13.6669 4.20756) scale(29.8836)"
          >
            <stop stop-color="white" />
            <stop offset="0.5" stop-color="#4C6B97" />
            <stop offset="1" stop-color="#231F20" />
          </radialGradient>
          <clipPath id="clip0_585_797">
            <rect width="45.52" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: "MySQL",
    icon: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_585_795)">
          <path
            d="M32.1806 26.863C30.274 26.8108 28.8182 26.9891 27.5727 27.5135C27.2191 27.6631 26.6553 27.6664 26.5976 28.1096C26.792 28.3136 26.8218 28.618 26.9768 28.869C27.2738 29.3486 27.7758 29.9936 28.2234 30.3324C28.7126 30.701 29.2168 31.0961 29.7413 31.4155C30.6748 31.9848 31.7163 32.3096 32.6135 32.8789C33.1434 33.2153 33.6687 33.6383 34.1857 34.0175C34.4411 34.2046 34.6131 34.496 34.944 34.6136V34.5603C34.7698 34.3383 34.725 34.0326 34.5647 33.801L33.8598 33.096C33.1707 32.1817 32.296 31.3786 31.3669 30.7119C30.6256 30.179 28.9658 29.4601 28.6571 28.5983L28.6027 28.5438C29.1282 28.484 29.7435 28.2939 30.2294 28.1635C31.0442 27.9456 31.7729 28.0022 32.6135 27.7842L33.7521 27.4597V27.2428C33.3269 26.807 33.0236 26.2292 32.5602 25.8341C31.3458 24.8002 30.0213 23.7683 28.6574 22.9075C27.9011 22.4301 26.9664 22.1192 26.1645 21.7145C25.8943 21.5789 25.421 21.5072 25.2427 21.2808C24.8219 20.7446 24.5922 20.0643 24.2676 19.4384C23.5873 18.1278 22.9196 16.6977 22.3161 15.3188C21.9048 14.379 21.6369 13.4517 21.1242 12.609C18.6632 8.56295 16.0145 6.12034 11.9107 3.7201C11.0371 3.2096 9.98598 3.0078 8.875 2.74393L7.0859 2.63592C6.72168 2.48417 6.34352 2.03874 6.00172 1.8219C4.64246 0.962487 1.15504 -0.905638 0.147699 1.55092C-0.48777 3.10077 1.09844 4.61315 1.66555 5.39928C2.06395 5.94944 2.57336 6.56768 2.85746 7.18729C3.04559 7.59526 3.07758 8.00323 3.23782 8.43389C3.63102 9.49565 3.97473 10.6512 4.48442 11.6317C4.74172 12.1283 5.02582 12.6508 5.35176 13.0952C5.55055 13.3675 5.89317 13.4884 5.94785 13.9081C5.61235 14.3771 5.59321 15.1044 5.40535 15.6972C4.55825 18.3687 4.87871 21.6882 6.11028 23.6644C6.48844 24.2722 7.3793 25.573 8.60321 25.0742C9.67453 24.6372 9.43528 23.2862 9.7418 22.0932C9.81125 21.823 9.7686 21.6242 9.90422 21.4427V21.4971L10.8804 23.4475C11.6025 24.6107 12.8831 25.8262 13.9694 26.6465C14.5324 27.0717 14.9757 27.8064 15.7041 28.0552V28.0008H15.6497C15.5086 27.7807 15.2877 27.6899 15.1083 27.5138C14.6842 27.0974 14.2122 26.5803 13.8617 26.104C12.8738 24.7636 12.0009 23.2958 11.2063 21.7686C10.826 21.0391 10.4959 20.2349 10.1755 19.4925C10.0516 19.2062 10.0538 18.7726 9.79622 18.6252C9.44594 19.1688 8.92887 19.609 8.65762 20.2508C8.22504 21.2773 8.16844 22.5301 8.00821 23.8279C7.91305 23.8621 7.95489 23.8385 7.89938 23.8823C7.14414 23.6996 6.87946 22.9231 6.59836 22.2556C5.88907 20.5701 5.75672 17.856 6.38153 15.9143C6.54286 15.4123 7.27348 13.8315 6.97762 13.367C6.83653 12.9046 6.37086 12.6364 6.11028 12.2828C5.78762 11.8458 5.46633 11.2703 5.24293 10.7649C4.66188 9.45108 4.39172 7.97506 3.7795 6.64643C3.48692 6.01096 2.99336 5.36784 2.58758 4.80401C2.13778 4.17811 1.63493 3.71655 1.28657 2.96049C1.1627 2.69143 0.995082 2.26077 1.17774 1.98542C1.23653 1.79839 1.31883 1.72046 1.5034 1.65975C1.81731 1.41721 2.6934 1.74096 3.02016 1.87659C3.88969 2.23753 4.61485 2.58151 5.35176 3.0696C5.70422 3.30339 6.06215 3.75647 6.48926 3.88253H6.97735C7.73996 4.0578 8.59446 3.93585 9.30786 4.15268C10.5681 4.53604 11.6972 5.13213 12.7225 5.77936C15.8457 7.75221 18.4007 10.559 20.148 13.9098C20.4288 14.4492 20.5508 14.963 20.7985 15.5353C21.2973 16.689 21.9264 17.8757 22.423 19.0047C22.9196 20.1294 23.4025 21.266 24.1041 22.2026C24.4727 22.695 25.8954 22.9589 26.5426 23.2323C26.9965 23.4235 27.74 23.6233 28.1693 23.8828C28.9896 24.3775 29.7842 24.967 30.5545 25.5084C30.9379 25.7797 32.1213 26.3747 32.1801 26.8639L32.1806 26.863ZM7.9527 6.21303C7.55539 6.20565 7.27457 6.25569 6.97762 6.32104V6.37546H7.03094C7.22098 6.76428 7.55539 7.0153 7.79028 7.35053L8.33168 8.48913L8.3861 8.43581C8.72161 8.19874 8.87528 7.82057 8.87309 7.2428C8.73856 7.10061 8.71942 6.92452 8.60184 6.75471C8.44817 6.5294 8.14793 6.40225 7.95243 6.21331L7.9527 6.21303Z"
            fill="#00618A"
          />
        </g>
        <defs>
          <clipPath id="clip0_585_795">
            <rect width="35" height="35" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: "Mongo DB",
    icon: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.9688 6.01562H19.9062L17.6094 10.6094H4.70312V28.9844H32.2656V6.01562H29.9688ZM29.9688 26.4688H7.21875V12.9062H29.9688V26.4688ZM29.9688 10.6094H21L22.0938 8.3125H29.8594V10.6094H29.9688ZM28.1094 14.9844H0.546875L4.70312 28.9844H32.2656L28.1094 14.9844Z"
          fill="#78C47C"
        />
        <path
          d="M29.2849 33.9061L28.6692 33.7015C28.6692 33.7015 28.7479 30.5832 27.6235 30.3656C26.882 29.5059 27.7329 -6.33629 30.4312 30.2431C29.9188 30.5023 29.5268 30.95 29.3374 31.4921C29.236 32.2928 29.2184 33.1018 29.2849 33.9061Z"
          fill="url(#paint0_linear_585_790)"
        />
        <path
          d="M29.6177 30.8951C31.2574 29.6598 32.5129 27.9847 33.2386 26.0643C33.9642 24.1439 34.1301 22.0571 33.7171 20.0462C32.514 14.7262 29.6582 12.9772 29.3509 12.3101C29.0851 11.8944 28.8585 11.455 28.6738 10.9976L28.9013 25.8201C28.9013 25.8201 28.4299 30.3493 29.6177 30.8951Z"
          fill="url(#paint1_linear_585_790)"
        />
        <path
          d="M28.3554 31.092C28.3554 31.092 23.334 27.6719 23.625 21.6223C23.6524 19.7986 24.0707 18.0019 24.8516 16.3536C25.6326 14.7053 26.758 13.2436 28.152 12.0673C28.3145 11.9285 28.4437 11.7549 28.5298 11.5593C28.616 11.3636 28.657 11.1511 28.6497 10.9375C28.9625 11.6102 28.9111 20.9803 28.9439 22.0763C29.0718 26.3397 28.7076 30.287 28.3554 31.092Z"
          fill="url(#paint2_linear_585_790)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_585_790"
            x1="25.1429"
            y1="22.6285"
            x2="32.2243"
            y2="25.0308"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.231" stop-color="#999875" />
            <stop offset="0.563" stop-color="#9B9977" />
            <stop offset="0.683" stop-color="#A09F7E" />
            <stop offset="0.768" stop-color="#A9A889" />
            <stop offset="0.837" stop-color="#B7B69A" />
            <stop offset="0.896" stop-color="#C9C7B0" />
            <stop offset="0.948" stop-color="#DEDDCB" />
            <stop offset="0.994" stop-color="#F8F6EB" />
            <stop offset="1" stop-color="#FBF9EF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_585_790"
            x1="27.7405"
            y1="10.8917"
            x2="30.8711"
            y2="30.4388"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#48A547" />
            <stop offset="1" stop-color="#3F9143" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_585_790"
            x1="23.1927"
            y1="22.2212"
            x2="31.5932"
            y2="19.4078"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#41A247" />
            <stop offset="0.352" stop-color="#4BA74B" />
            <stop offset="0.956" stop-color="#67B554" />
            <stop offset="1" stop-color="#69B655" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
];

const Profile = () => {
  const [Profiles, setProfile] = useState([]);
  const [loading, setLoading] = useState(true); // Error state if needed
  const User = getUserData();
  useEffect(() => {
    let isMounted = true;
    async function getProfileAll() {
      try {
        const response = await api.getprofileByUserid(User?._id);
        if (response.status !== 400) {
          if (isMounted) {
            setProfile(response);
            setLoading(false);
          }
        } else if (response.status == 400) {
        }
      } catch (error) {
        console.error(error);
        // Handle error
      }
    }

    getProfileAll();
    return () => {
      isMounted = false;
    };
  }, [User?._id]);
  const { openPopup } = usePopup();
  // const [popupComponent, setPopupComponent] = useState(null);
  const toastRef = useRef();
  const handleClosePopup = (message) => {
    //console.log(message);
    //setPopupComponent(null);
    openPopup();
  };
  const handleDeleteClick = async (profileId) => {
    const popup = (
      <Deleteprofile
        onClose={() => handleClosePopup("Popup closed")}
        profile_id={profileId}
      />
    );
    //setPopupComponent(popup);
    openPopup(popup);
  };
  const [selectedProfileId, setSelectedProfileId] = useState(null);
  const handleSelect = async (profileId) => {
    try {
      // Call the backend API to set the default profile
      const response = await api.updateDefaultProfile(profileId);

      if (response.status === 200) {
        // Update the local state to reflect the new default profile
        setSelectedProfileId(profileId);
        toastRef.current.addToast(response.message, "success");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toastRef.current.addToast(response.message, "error");
      }
    } finally {
    }
  };

  const ProfileCard = ({
    profile_id,
    name,
    profileimg,
    jobTitle,
    profileUrl,
    cvUrl,
    selected,
    onSelect,
    profiledata,
    downloadRef,
  }) => {
    const [hovered, setHovered] = useState(false);
    const handleDownload = (profiledata) => {
      downloadRef.current.downloadCV(profiledata);
    };
    return (
      <div
        className={`md:flex items-center ProfileCard-dash p-4 mb-4 border-2 rounded md:rounded-full  ${
          selected ? "hrp-card-border-active " : "hrp-card-border"
        }`}
      >
        <img
          alt="Profile"
          className="w-12 h-12 rounded-full mr-4"
          src={
            profileimg && profileimg.trim() !== "" && profileimg !== "NA"
              ? profileimg.startsWith("http://") ||
                profileimg.startsWith("https://")
                ? profileimg
                : profileimg.startsWith("/uploads/")
                ? `${domainpath}${profileimg}`
                : `${domainpath}/uploads/${profileimg}`
              : `${domainpath}/uploads/deafultman.png`
          }
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = `${domainpath}/uploads/deafultman.png`;
          }}
        />
        <div className="flex-grow ">
          <a href={"/profile/" + profile_id}>
            <h2
              className={`md:text-lg font-bold  ${
                selected
                  ? "hrp-profile-selected-active"
                  : "hrp-profile-selected"
              }`}
            >
              {jobTitle}
            </h2>
          </a>
          <div className="text-sm text-blue-500">
            <a href={"/profile/" + profile_id} className="mr-2">
              View Profile
            </a>
            <span
              className="cursor-pointer	"
              onClick={(e) => handleDownload(profiledata)}
            >
              Download CV
            </span>
            <ProfileDownload
              ref={downloadRef}
              Profiles={profiledata}
              domainpath={domainpath}
              tools={tools}
            />
          </div>
        </div>
        <div className="flex items-center justify-end card-icon-section">
          <Link to={"/dashboard/profile/" + profile_id}>
            <svg
              className=""
              width={"16px"}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              fill=""
            >
              <path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" />
            </svg>
          </Link>
          &nbsp; &nbsp;
          <div
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          >
            <input
              type="checkbox"
              checked={profiledata?.defaultProfile}
              onChange={onSelect}
              className={`form-checkbox h-5 w-5 border-2 cursor-pointer ${
                selected
                  ? "bg-yellow-500 border-yellow-500 "
                  : "bg-blue-500 border-blue-500"
              }`}
            />
            {hovered && (
              <div
                className="absolute mt-2 p-2 text-xs text-white bg-gray-800 rounded "
                style={{ left: "50%" }}
              >
                Default
              </div>
            )}
          </div>
          &nbsp; &nbsp;
          <div
            className="hrp-cursor cursor-pointer"
            onClick={() => handleDeleteClick(profile_id)}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_69_57)">
                <path
                  d="M28.3333 7.08301C28.7091 7.08301 29.0694 7.23226 29.3351 7.49794C29.6007 7.76362 29.75 8.12395 29.75 8.49967C29.75 8.8754 29.6007 9.23573 29.3351 9.50141C29.0694 9.76709 28.7091 9.91634 28.3333 9.91634H26.9167L26.9124 10.0169L25.5907 28.5342C25.5398 29.249 25.2199 29.918 24.6955 30.4064C24.1711 30.8948 23.4811 31.1664 22.7644 31.1663H11.2342C10.5175 31.1664 9.82751 30.8948 9.30309 30.4064C8.77866 29.918 8.4588 29.249 8.40792 28.5342L7.08617 10.0183L7.08333 9.91634H5.66667C5.29094 9.91634 4.93061 9.76709 4.66493 9.50141C4.39926 9.23573 4.25 8.8754 4.25 8.49967C4.25 8.12395 4.39926 7.76362 4.66493 7.49794C4.93061 7.23226 5.29094 7.08301 5.66667 7.08301H28.3333ZM24.0791 9.91634H9.92092L11.2356 28.333H22.7644L24.0791 9.91634ZM19.8333 2.83301C20.2091 2.83301 20.5694 2.98226 20.8351 3.24794C21.1007 3.51362 21.25 3.87395 21.25 4.24967C21.25 4.6254 21.1007 4.98573 20.8351 5.25141C20.5694 5.51709 20.2091 5.66634 19.8333 5.66634H14.1667C13.7909 5.66634 13.4306 5.51709 13.1649 5.25141C12.8993 4.98573 12.75 4.6254 12.75 4.24967C12.75 3.87395 12.8993 3.51362 13.1649 3.24794C13.4306 2.98226 13.7909 2.83301 14.1667 2.83301H19.8333Z"
                  fill="#FF0000"
                />
              </g>
              <defs>
                <clipPath id="clip0_69_57">
                  <rect width="34" height="34" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    );
  };
  const downloadRefs = Profiles?.reduce((acc, profile) => {
    acc[profile._id] = React.createRef();
    return acc;
  }, {});
  return (
    <>
      <PopupProvider>
        <div className="">
          <div className="">
            <div className="xl:w-1/2 md:w-full">
              <div className="container mx-auto p-4">
                <div className="">
                  <h1 className="text-lg font-bold hrp-profile-selected-active text-center">
                    Your Active Profile
                  </h1>
                  <div className="md:p-4 hrp-mobile-height md:h-96 overflow-y-scroll overflow-x-hidden custom-scrollbar">
                    {loading ? (
                      <div className="text-center">
                        <p>Loading...</p>
                      </div>
                    ) : Profiles.length === 0 ? (
                      <div className="text-center">
                        <p>No Profile Created yet</p>
                        <a
                          className="m-auto mt-2 inline-block text-blue-500 hover:underline"
                          href="/dashboard/create-profile"
                        >
                          <span>Create Profile</span>
                        </a>
                      </div>
                    ) : (
                      <>
                        {Array.isArray(Profiles) &&
                        Profiles.length > 0 &&
                        Array.isArray(Profiles) === true ? (
                          <>
                            {(Profiles || []).map((profile) => (
                              <ProfileCard
                                key={profile._id}
                                profile_id={profile._id}
                                profileimg={profile.jobProfileImage}
                                name={profile.name}
                                jobTitle={profile.jobTitle}
                                profileUrl={profile.profileUrl}
                                cvUrl={profile.cvUrl}
                                profiledata={profile}
                                selected={profile._id === selectedProfileId} // Note the use of profile._id here
                                onSelect={() => handleSelect(profile._id)}
                                handleDeleteClick={(e) =>
                                  handleDeleteClick(profile._id)
                                }
                                downloadRef={downloadRefs[profile._id]}
                              />
                            ))}
                            {Profiles?.map((profile) => (
                              <ProfileDownload
                                key={profile._id}
                                ref={downloadRefs[profile._id]} // Use the same ref to trigger download
                                Profiles={profile}
                                domainpath={domainpath}
                                tools={tools}
                              />
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                        <div className="flex justify-end mt-4">
                          <button className="joblist-btnclear">Update</button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PopupProvider>{" "}
      <CustomToastContainer ref={toastRef} />
    </>
  );
};

export default Profile;
